"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _getProgramLayers = require("@studio/program/utils/getProgramLayers");
var _toggleProgramSource = _interopRequireDefault(require("../program/toggleProgramSource"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * In the event that the director is leaving the program,
 * remove the director's source from Program
 * and update the Scene appropriately.
 */
function removeDirectorAttendee(setProgram, meetingAttendeeId) {
  return function (dispatch, getState) {
    var _meeting$attendeeResp;
    var _getState = getState(),
      meeting = _getState.meeting,
      program = _getState.program;
    var attendeeId = meetingAttendeeId || (meeting === null || meeting === void 0 || (_meeting$attendeeResp = meeting.attendeeResponse) === null || _meeting$attendeeResp === void 0 || (_meeting$attendeeResp = _meeting$attendeeResp.Attendee) === null || _meeting$attendeeResp === void 0 ? void 0 : _meeting$attendeeResp.AttendeeId);
    var layers = (0, _getProgramLayers.getProgramLayers)(program);
    var directorLayer = layers === null || layers === void 0 ? void 0 : layers.find(function (layer) {
      var _layer$source;
      return (layer === null || layer === void 0 || (_layer$source = layer.source) === null || _layer$source === void 0 ? void 0 : _layer$source.value) === attendeeId;
    });
    /**
     * If director layer exist in scene/program
     * We'll want to remove it from program
     */
    if (!!directorLayer) {
      var directorSource = directorLayer.source;
      directorSource && dispatch((0, _toggleProgramSource["default"])(directorSource, setProgram));
    }
  };
}
var _default = exports["default"] = removeDirectorAttendee;